module.exports = __webpack_public_path__ + "img/VC.8b1eb608.svg";